import { ViewDatesOutput } from '../../../../generated/graphql.generated';
import { LoadingState } from '../../../utilities/state.util';

export const overviewTimelineInitialState = {
  timelineActionsEventId: undefined as string | undefined,
  timeline: [] as string[],
  viewDatesMap: {} as Record<string, ViewDatesOutput>,
  viewDatesLoading: LoadingState.INIT as LoadingState,
};

export type OverviewTimelineState = typeof overviewTimelineInitialState;
